<div fxLayout="row layout-wrap"
     fxLayout.xs="column"
     fxLayoutGap.gt-xs="24px"
     fxLayoutGap.xs="12px"
     fxLayoutAlign="space-between start"
     fxLayoutAlign.xs="center center"
     class="w-100 hip__buttons"
     ngClass.gt-xs="pb-4"
     *ngIf="buttons && buttons.showButtons">

  <div fxLayout="row layout-wrap"
       fxLayout.xs="column"
       fxLayoutGap="24px"
       fxLayoutGap.xs="12px"
       fxLayoutAlign="space-between start"
       fxLayoutAlign.xs="center center"
       ngClass.xs="w-100"
       class="hip__buttons-box"
       *ngIf="object">

    <ng-template [permission]="buttons.hashButtons.add">
      <button *ngIf="!object[buttons.propertyId] && buttons.create"
              aria-label="Adicionar"
              color="primary"
              mat-raised-button
              ngClass.xs="w-100"
              [disabled]="!valid"
              (click)="buttonsEmmiter.emit(events.CREATE)">
        <mat-icon>save</mat-icon>
        ADICIONAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.resend">
      <button *ngIf="!object[buttons.propertyId] && buttons.resend"
              aria-label="Reenviar"
              color="primary"
              mat-raised-button
              ngClass.xs="w-100"
              [disabled]="!valid"
              (click)="buttonsEmmiter.emit(events.RESEND)">
        <mat-icon>send</mat-icon>
        REENVIAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.save">
      <button *ngIf="object[buttons.propertyId] && disabled && buttons.update"
              aria-label="Salvar"
              mat-raised-button
              color="primary"
              ngClass.xs="w-100"
              [disabled]="!valid"
              (click)="buttonsEmmiter.emit(events.UPDATE)">
        <mat-icon>save</mat-icon>
        SALVAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.edit">
      <button *ngIf="object[buttons.propertyId] && !disabled && buttons.update"
              aria-label="Editar"
              color="primary"
              mat-raised-button
              ngClass.xs="w-100"
              (click)="buttonsEmmiter.emit(events.EDIT)">
        <mat-icon>edit_note</mat-icon>
        EDITAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.cancel">
      <button *ngIf="object[buttons.propertyId] && disabled && buttons.update"
              aria-label="Cancelar"
              color="primary"
              mat-stroked-button
              ngClass.xs="w-100"
              (click)="buttonsEmmiter.emit(events.CANCEL)">
        <mat-icon>close</mat-icon>
        CANCELAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.unlock">
      <button *ngIf="object[buttons.propertyId] && object[buttons.propertyActive] && !disabled && buttons.enable"
              aria-label="Habilitar"
              color="primary"
              mat-raised-button
              ngClass.xs="w-100"
              (click)="buttonsEmmiter.emit(events.UNLOCK)">
        <mat-icon>check_circle</mat-icon>
        DESBLOQUEAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.lock">
      <button *ngIf="object[buttons.propertyId]  && (!object[buttons.propertyActive] && object[buttons.propertyActive] != null) && !disabled && buttons.enable"
              aria-label="Desabilitar"
              color="primary"
              mat-raised-button
              ngClass.xs="w-100"
              (click)="buttonsEmmiter.emit(events.LOCK)">
        <mat-icon>block</mat-icon>
        BLOQUEAR
      </button>
    </ng-template>

    <ng-template [permission]="buttons.hashButtons.delete">
      <button *ngIf="object[buttons.propertyId] && !disabled && buttons.delete"
              aria-label="Deletar"
              color="primary"
              mat-raised-button
              ngClass.xs="w-100"
              (click)="buttonsEmmiter.emit(events.DELETE)">
        <mat-icon>delete</mat-icon>
        DELETAR
      </button>
    </ng-template>

    <ng-content> </ng-content>
  </div>

  <button *ngIf="buttons.back"
          aria-label="voltar"
          class="mr-0 hip__back"
          color="primary"
          fxFlexAlign.gt-xs="end"
          mat-stroked-button
          ngClass.xs="w-100"
          type="button"
          (click)="buttonsEmmiter.emit(events.BACK)">
    <mat-icon>keyboard_backspace</mat-icon>
    VOLTAR
  </button>

  <mat-divider class="w-100 mt-3"
               ngClass.xs="mb-3"
               *ngIf="!hiddenLine">
  </mat-divider>
</div>
